<template>
  <template v-if="mode === 'view'">
    <div :class="sizeClass">
      <p class="text-sm mb-2">{{ label }}</p>
      <p class="mb-2">{{ modelValue }}</p>
    </div>
  </template>
  <div v-else>
    <template v-if="attributes.type === 'select'">
      <FormKit
        :label="label"
        :name="name"
        type="select"
        :options="attributes.options"
        :model-value="modelValue"
        :outer-class="`!m-0 ${sizeClass}`"
        @update:model-value="val => emit('update:model-value', val ?? '')"
      />
    </template>
    <template v-if="attributes.type === 'number'">
      <Field class="gap-1">
        <FieldLabel :for="name" class="mb-0">{{ label }}</FieldLabel>
        <DecimalInput
          :id="name"
          :model-value="modelValue"
          :class="`${sizeClass} mt-0`"
          :decimal-places="attributes.decimalPlaces ?? 10"
          @update:model-value="val => emit('update:model-value', val)"
        />
      </Field>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { ActionItemMode } from '../actions/types';
import DecimalInput from '@/components/shared/DecimalInput/index.vue';
import { Field, FieldLabel } from '@/components/ui/field';

export type ViewAndEditAttributes = { type: 'number'; decimalPlaces?: number } | { type: 'select'; options: string[] };

type ViewAndEditProps = {
  modelValue: string;
  label: string;
  mode: ActionItemMode;
  attributes: ViewAndEditAttributes;
  size?: 'xs' | 'sm' | 'md';
};

const { size = 'md', label } = defineProps<ViewAndEditProps>();

const sizeClass = computed(() => {
  if (size === 'xs') return 'width-xs';
  if (size == 'sm') return 'width-sm';
  if (size == 'md') return 'width-md';
  return '';
});

const name = computed(() => label.toLowerCase().replace(/ /g, '_'));

type Emits = {
  'update:model-value': [val: string];
};

const emit = defineEmits<Emits>();
</script>

<style scoped>
.width-md {
  @apply w-[18rem] max-w-[18rem];
}

.width-sm {
  @apply w-[14rem] max-w-[14rem];
}

.width-xs {
  @apply w-[10rem] max-w-[10rem];
}
</style>
